import React from 'react'
import { ForwardInboxIcon, Span, Button, Input } from '../../lib/components'
import { IFormProps } from '../../lib/types'
import { FormikProps, Formik } from 'formik'
import {
  RESEND_VERIFICATION_EMAIL_TEXT01,
  RESEND_VERIFICATION_EMAIL_TEXT02,
  CONTINUE,
} from '../../lib/utils/message'

const ResendVerificationPresenter = ({
  initialValues,
  handleFormSubmit,
  validationSchema,
}: IFormProps) => {
  return (
    <>
      <ForwardInboxIcon />
      <Span classes={['mt-29']} text={RESEND_VERIFICATION_EMAIL_TEXT01} variant='default' />
      <Span text={RESEND_VERIFICATION_EMAIL_TEXT02} variant='default' />
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleFormSubmit}
      >
        {(formik) => {
          const {
            values,
            touched,
            errors,
            dirty,
            handleChange,
            handleSubmit,
          }: FormikProps<typeof initialValues> = formik
          return (
            <form className='w-80 mt-32'>
              <Input
                name='email'
                placeholder='Email'
                type='text'
                required
                value={values.email}
                handleChange={handleChange(initialValues.email)}
                dirty={dirty}
                errors={{
                  email: !!errors && errors.email ? errors.email : null,
                }}
                touched={{ email: !!touched && !!touched.email }}
                data-testid='resend-verification-email-input'
              />
              <Button
                classes={['mt-13']}
                variant={'primary-btn'}
                text={CONTINUE}
                handleClick={handleSubmit}
              />
            </form>
          )
        }}
      </Formik>
    </>
  )
}

export { ResendVerificationPresenter }
